import auth from 'app/core/auth';
import { type InternalAxiosRequestConfig } from 'axios';
import i18Next from 'i18next';

export const authTokenInterceptor = async (config: InternalAxiosRequestConfig) => {
  const user = await auth.getUser();
  if (user) {
    config.headers.Authorization = `Bearer ${user.access_token}`;
  }
  const allowMethos = ['POST', 'post', 'DELETE', 'delete', 'PUT', 'put'];
  if (config.headers?.lang || allowMethos.some((x) => x == config.method)) {
    config.headers['Accept-Language'] = i18Next.language;
  } else {
    config.headers['Accept-Language'] = '';
  }

  return config;
};
